import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, ModalHeader, ModalBody, Spinner } from "reactstrap";
import { deleteCatalogsByID } from "store/actions/catalogAction";
import { deleteAdditionalCharge } from "store/actions/settingAction";
import { removeTip } from "store/actions/settingAction";
import { removeHoliday } from "store/actions/settingAction";
function DeleteCatalogModal({
  deleteModal,
  deleteToggle,
  title,
  editData,
  id,
  deleteLoading
}) {
  const dispatch = useDispatch();
  const handleModalClick = (e) => {
    if (e.target.closest(".modal-content")) {
      return;
    }
    deleteToggle();
  };

  const HandleDeleteBtn = () => {
    if (title == "Catalog") {
      dispatch(
        deleteCatalogsByID(id, () => {
          deleteToggle();
        })
      );
    } else if (title == "Holidays") {
      dispatch(
        removeHoliday(id, editData, () => {
          deleteToggle();
        })
      );
    } else if (title == "Tip") {
      dispatch(
        removeTip(id, editData, () => {
          deleteToggle();
        })
      );
    } else if (title == "Charge") {
      dispatch(
        deleteAdditionalCharge(id, editData, () => {
          deleteToggle();
        })
      );
    }
  };
  return (
    <div>
      <Modal
        isOpen={deleteModal}
        toggle={deleteToggle}
        onClick={handleModalClick}
      >
        <ModalHeader toggle={deleteToggle}>Delete {title}</ModalHeader>
        <ModalBody>
          <h3>Are you sure you want to delete ?</h3>

          <div className="d-flex justify-content-end">
            <Button
              color="primary"
              onClick={HandleDeleteBtn}
              disabled={deleteLoading}
            >
              {deleteLoading ? <Spinner size="sm" /> : "Delete"}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default DeleteCatalogModal;
